import React from "react";
import { Box, Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import ModalWrapper from "../ModalWrapper/ModalWrapper";
import SingleProduct from "../../pages/SingleProduct/SingleProduct";

const BomProductQuickView = ({ open, productId, machineId, onClose }) => {
	const { t } = useTranslation();
	const hasSelection = Boolean(productId && machineId);

	return (
		<ModalWrapper
			open={open}
			setOpen={() => {}}
			onClose={onClose}
			title={t("UI_TEXT.VIEW_BOM")}
			subtitle={
				hasSelection
					? `${t("LABELS.MACHINE")} #${machineId}`
					: t("UI_TEXT.SELECT_PARTS_IN_BOM_TREE")
			}
			width="80vw"
			content={
				hasSelection ? (
					<Box sx={{ height: "72vh", p: 1, display: "flex", flexDirection: "column" }}>
						<SingleProduct machineID={machineId} productID={productId} isModalView />
					</Box>
				) : (
					<Alert severity="info">{t("UI_TEXT.SELECT_PARTS_IN_BOM_TREE")}</Alert>
				)
			}
			actions={
				<Button onClick={onClose}>{t("BUTTON.CLOSE") || "Close"}</Button>
			}
		/>
	);
};

export default BomProductQuickView;
